import { render, staticRenderFns } from "./Publisher.vue?vue&type=template&id=78e6b7e5"
import script from "./Publisher.vue?vue&type=script&lang=js"
export * from "./Publisher.vue?vue&type=script&lang=js"
import style0 from "./Publisher.vue?vue&type=style&index=0&id=78e6b7e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports